import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import useTechCopy from "../useTechCopy";
import SectionHeader from "../ui/SectionHeader";

const ACCENT = "#64CEFB";

// Numerals light up one by one as the rail above them fills.
function Step({ step, index, count, progress }) {
  const at = (index + 1) / count;
  const color = useTransform(progress, [at - 0.12, at], ["rgba(255,255,255,0.45)", ACCENT]);
  return (
    <li>
      <motion.span className="block text-sm tabular-nums" style={{ color }}>
        {step.n}
      </motion.span>
      <h3 className="mt-3 text-2xl font-medium tracking-tight text-white">{step.title}</h3>
      <p className="mt-3 max-w-xs text-white/70 leading-relaxed">{step.desc}</p>
    </li>
  );
}

// The only numbered section: the steps really are a sequence. A single rail
// fills in the hero's blue as the strip scrolls through the viewport.
export default function ProcessSection() {
  const copy = useTechCopy().process;
  const stripRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: stripRef,
    offset: ["start 85%", "end 55%"],
  });

  return (
    <section id="process" className="relative bg-black px-6 sm:px-10 lg:px-16 py-24 lg:py-32">
      <div className="max-w-[1600px] mx-auto">
        <SectionHeader title={copy.title} lede={copy.lede} />

        <div ref={stripRef} className="mt-14 lg:mt-24">
          <div className="relative h-px bg-white/10" aria-hidden="true">
            <motion.div
              className="absolute inset-y-0 left-0 w-full origin-left"
              style={{ scaleX: scrollYProgress, background: ACCENT }}
            />
          </div>
          <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12 pt-8">
            {copy.steps.map((s, i) => (
              <Step key={s.n} step={s} index={i} count={copy.steps.length} progress={scrollYProgress} />
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
